window.addEventListener("load", function () {
  const panel = document.getElementById("nth-ld-frame2-search-mb");
  if (!panel) return;

  const main = document.getElementById("nth-ld-frame2");
  // Project có 2 section cùng id (MS__pc + MS__mb) — chỉ thao tác trên MS__mb
  const navMb = document.querySelector("#vxphl-ld-25-a-navigation.MS__mb");
  const btnSearch = navMb ? navMb.querySelector(".MS__sprite-icon-search.icon-search") : null;
  const btnBack = panel.querySelector(".search-bar__back");
  const input = panel.querySelector(".search-bar__input");

  function setActive(active) {
    panel.classList.toggle("active", active);

    // Khi mở search: đóng menu-mb panel nếu đang active để tránh content đè lên
    if (active) {
      const menuMb = document.getElementById("nth-ld-frame2-menu-mb");
      if (menuMb) menuMb.classList.remove("active");
    }

    // Override !important rule .MS__mb { display: block !important } bằng setProperty
    if (navMb) {
      if (active) navMb.style.setProperty("display", "none", "important");
      else navMb.style.removeProperty("display");
    }
    if (main) main.style.display = active ? "none" : "";

    if (active && input) setTimeout(function () { input.focus(); }, 50);
    if (!active && input) input.value = "";
    window.dispatchEvent(new Event("resize"));
  }

  if (btnSearch) {
    btnSearch.addEventListener("click", function (e) {
      e.preventDefault();
      setActive(!panel.classList.contains("active"));
    });
  }

  if (btnBack) {
    btnBack.addEventListener("click", function (e) {
      e.preventDefault();
      setActive(false);
    });
  }
});
